(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  function randomizeProductSections(root) {
    root.querySelectorAll('[data-random-products]').forEach((section) => {
      const pool = section.querySelector('[data-product-pool]');
      const grid = section.querySelector('[data-product-grid]');
      if (!pool || !grid || section.dataset.randomized) return;
      const cards = Array.from(pool.content.children);
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      const selected = cards.slice(0, Number(section.dataset.count));
      const fragment = document.createDocumentFragment();
      selected.forEach((card, index) => {
        const clone = card.cloneNode(true);
        clone.className = index > 3 ? 'hidden md:block' : '';
        clone.querySelectorAll('script, .skeleton-shimmer').forEach((node) => node.remove());
        clone.querySelectorAll('img').forEach((img) => {
          img.removeAttribute('onload');
          img.style.removeProperty('opacity');
        });
        fragment.appendChild(clone);
      });
      grid.replaceChildren(fragment);
      section.dataset.randomized = 'true';
      pool.remove();
    });
  }
  randomizeProductSections(document);
  document.addEventListener('shopify:section:load', (event) => randomizeProductSections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-order-lp"]) return;
  try {
    
  if (!customElements.get('pet-order-lp')) {
    customElements.define(
      'pet-order-lp',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;
          this.controller = new AbortController();
          const on = (target, event, handler, options = {}) =>
            target?.addEventListener(event, handler, { ...options, signal: this.controller.signal });
          this.querySelectorAll('a, button').forEach((control) => {
            Array.from(control.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE && /[↗↓↑→←]/.test(node.textContent)).forEach((node) => {
              const fragment = document.createDocumentFragment();
              node.textContent.split(/([↗↓↑→←])/).forEach((part) => {
                if (/^[↗↓↑→←]$/.test(part)) {
                  const arrow = document.createElement('span');
                  arrow.className = 'pet-arrow' + ({'↓':' pet-arrow-down','↑':' pet-arrow-up','↗':' pet-arrow-diagonal'}[part] || '');
                  arrow.setAttribute('aria-hidden', 'true');
                  arrow.textContent = part;
                  fragment.append(arrow);
                } else fragment.append(document.createTextNode(part));
              });
              node.replaceWith(fragment);
            });
          });
          const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.revealAnimations = new Set();
          if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
            this.revealObserver = new IntersectionObserver((entries) => {
              entries.forEach(({ target, isIntersecting }) => {
                if (!isIntersecting) return;
                this.revealObserver.unobserve(target);
                if (motionPreference.matches) return;
                const animation = target.animate(
                  [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'translateY(0)' }],
                  { duration: 750, easing: 'ease-out' },
                );
                this.revealAnimations.add(animation);
                animation.onfinish = () => this.revealAnimations.delete(animation);
              });
            }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
            this.querySelectorAll('.pet-hero > .pet-eyebrow, .pet-hero > h1, .pet-stage, .pet-section > .pet-eyebrow, .pet-section > h2, .pet-grid figure, .pet-steps li, .pet-artist-quote, .pet-months > div').forEach((element) => this.revealObserver.observe(element));
            on(motionPreference, 'change', () => {
              if (motionPreference.matches) {
                this.revealAnimations.forEach((animation) => animation.cancel());
                this.revealAnimations.clear();
              }
            });
          }
          const animate = (element, frames, duration = 360) => {
            if (motionPreference.matches) return null;
            const animation = element.animate(frames, { duration, easing: 'cubic-bezier(.22,.61,.36,1)' });
            this.revealAnimations.add(animation);
            animation.addEventListener('finish', () => this.revealAnimations.delete(animation));
            animation.addEventListener('cancel', () => this.revealAnimations.delete(animation));
            return animation;
          };
          const expansionStates = new WeakMap();
          const expand = (element, opening, prepare, finish) => {
            const previous = expansionStates.get(element);
            const height = element.getBoundingClientRect().height;
            previous?.animation?.cancel();
            prepare();
            const target = opening ? element.scrollHeight : (element.tagName === 'DETAILS' ? element.querySelector('summary').getBoundingClientRect().height : 0);
            const state = { opening };
            expansionStates.set(element, state);
            const done = () => {
              if (expansionStates.get(element) !== state) return;
              element.style.overflow = '';
              finish();
              expansionStates.delete(element);
            };
            element.style.overflow = 'hidden';
            state.animation = animate(element, [{height: `${height}px`}, {height: `${target}px`}]);
            if (state.animation) {
              state.animation.addEventListener('finish', done);
              state.animation.addEventListener('cancel', done);
            } else done();
          };
          this.querySelectorAll('.pet-faq details').forEach((details) => {
            on(details.querySelector('summary'), 'click', (event) => {
              event.preventDefault();
              const opening = !(expansionStates.get(details)?.opening ?? details.open);
              expand(details, opening, () => { details.open = true; }, () => { details.open = opening; });
            });
          });
          const carousel = this.querySelector('.pet-review-carousel');
          const slides = Array.from(this.querySelectorAll('.pet-review-card'));
          const counter = carousel?.querySelector('output');
          const navigation = carousel?.querySelector('.pet-review-nav');
          let current = 0;
          const show = (next) => {
            if (!slides.length) return;
            const previous = current;
            current = (next + slides.length) % slides.length;
            slides.forEach((slide, index) => {
              slide.hidden = index !== current;
            });
            if (previous !== current) {
              slides[current].querySelectorAll('p, footer').forEach((text) => {
                text.getAnimations().forEach((animation) => animation.cancel());
                animate(text, [{opacity: 0, transform: `translateX(${next > previous ? 24 : -24}px)`}, {opacity: 1, transform: 'translateX(0)'}], 440);
              });
            }
            if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
          };
          if (carousel) carousel.hidden = slides.length === 0;
          if (navigation) navigation.hidden = slides.length < 2;
          on(carousel?.querySelector('[data-review-prev]'), 'click', () => show(current - 1));
          on(carousel?.querySelector('[data-review-next]'), 'click', () => show(current + 1));
          on(carousel, 'keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            show(current + (event.key === 'ArrowRight' ? 1 : -1));
          });
          let origin = null;
          on(
            carousel,
            'touchstart',
            (event) => {
              origin = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
            },
            { passive: true },
          );
          on(
            carousel,
            'touchend',
            (event) => {
              if (!origin || !event.changedTouches.length) return;
              const dx = event.changedTouches[0].clientX - origin.x;
              const dy = event.changedTouches[0].clientY - origin.y;
              if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) show(current + (dx < 0 ? 1 : -1));
              origin = null;
            },
            { passive: true },
          );
          on(carousel, 'touchcancel', () => {
            origin = null;
          });
          on(this, 'shopify:block:select', (event) => {
            const card = event.target.closest('.pet-review-card');
            if (card) show(slides.indexOf(card));
          });
          show(0);
          const toggle = this.querySelector('.pet-price-toggle');
          const extra = this.querySelector('#pet-extra-prices');
          on(toggle, 'click', () => {
            const opening = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(opening));
            toggle.querySelector('span').textContent = opening ? '−' : '+';
            expand(extra, opening, () => { extra.hidden = false; }, () => { extra.hidden = !opening; });
          });
          this.querySelectorAll('dialog').forEach((modal) => {
            let opener;
            const selector = modal.id === 'pet-size-modal' ? '[data-pet-size]' : '[data-pet-policy]';
            this.querySelectorAll(selector).forEach((button) => on(button, 'click', () => {
              opener = button;
              modal.showModal();
              animate(modal, [{opacity: 0, transform: 'translateY(14px) scale(.98)'}, {opacity: 1, transform: 'translateY(0) scale(1)'}], 300);
            }));
            modal.querySelectorAll('[data-pet-close]').forEach((button) => on(button, 'click', () => modal.close()));
            on(modal, 'close', () => opener?.focus({preventScroll:true}));
            on(modal, 'click', (event) => {
              const rect = modal.getBoundingClientRect();
              if (event.target === modal && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) modal.close();
            });
          });
          const sticky = this.querySelector('.pet-sticky');
          const hero = this.querySelector('.pet-hero');
          const formSection = this.querySelector('#pet-order-form');
          const updateSticky = () => {
            sticky.hidden =
              hero.getBoundingClientRect().bottom > 0 || formSection.getBoundingClientRect().top < window.innerHeight;
          };
          this.observer = new IntersectionObserver(updateSticky);
          this.observer.observe(hero);
          this.observer.observe(formSection);
          on(window, 'resize', updateSticky);
          updateSticky();
          const result = this.querySelector('[data-form-result]');
          if (result) {
            result.focus();
            result.scrollIntoView({ block: 'center' });
          }
        }
        disconnectedCallback() {
          this.querySelectorAll('dialog').forEach((modal) => modal.close());
          this.controller?.abort();
          this.controller = null;
          this.observer?.disconnect();
          this.revealObserver?.disconnect();
          this.revealAnimations?.forEach((animation) => animation.cancel());
          this.revealAnimations?.clear();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-room-content"]) return;
  try {
    
  if (!customElements.get('pet-order-lp')) {
    customElements.define(
      'pet-order-lp',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;
          this.controller = new AbortController();
          const on = (target, event, handler, options = {}) =>
            target?.addEventListener(event, handler, { ...options, signal: this.controller.signal });
          this.querySelectorAll('a, button').forEach((control) => {
            Array.from(control.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE && /[↗↓↑→←]/.test(node.textContent)).forEach((node) => {
              const fragment = document.createDocumentFragment();
              node.textContent.split(/([↗↓↑→←])/).forEach((part) => {
                if (/^[↗↓↑→←]$/.test(part)) {
                  const arrow = document.createElement('span');
                  arrow.className = 'pet-arrow' + ({'↓':' pet-arrow-down','↑':' pet-arrow-up','↗':' pet-arrow-diagonal'}[part] || '');
                  arrow.setAttribute('aria-hidden', 'true');
                  arrow.textContent = part;
                  fragment.append(arrow);
                } else fragment.append(document.createTextNode(part));
              });
              node.replaceWith(fragment);
            });
          });
          const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.revealAnimations = new Set();
          if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
            this.revealObserver = new IntersectionObserver((entries) => {
              entries.forEach(({ target, isIntersecting }) => {
                if (!isIntersecting) return;
                this.revealObserver.unobserve(target);
                if (motionPreference.matches) return;
                const animation = target.animate(
                  [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'translateY(0)' }],
                  { duration: 750, easing: 'ease-out' },
                );
                this.revealAnimations.add(animation);
                animation.onfinish = () => this.revealAnimations.delete(animation);
              });
            }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
            this.querySelectorAll('.pet-hero > .pet-eyebrow, .pet-hero > h1, .pet-stage, .pet-section > .pet-eyebrow, .pet-section > h2, .pet-grid figure, .pet-steps li, .pet-artist-quote, .pet-months > div').forEach((element) => this.revealObserver.observe(element));
            on(motionPreference, 'change', () => {
              if (motionPreference.matches) {
                this.revealAnimations.forEach((animation) => animation.cancel());
                this.revealAnimations.clear();
              }
            });
          }
          const animate = (element, frames, duration = 360) => {
            if (motionPreference.matches) return null;
            const animation = element.animate(frames, { duration, easing: 'cubic-bezier(.22,.61,.36,1)' });
            this.revealAnimations.add(animation);
            animation.addEventListener('finish', () => this.revealAnimations.delete(animation));
            animation.addEventListener('cancel', () => this.revealAnimations.delete(animation));
            return animation;
          };
          const expansionStates = new WeakMap();
          const expand = (element, opening, prepare, finish) => {
            const previous = expansionStates.get(element);
            const height = element.getBoundingClientRect().height;
            previous?.animation?.cancel();
            prepare();
            const target = opening ? element.scrollHeight : (element.tagName === 'DETAILS' ? element.querySelector('summary').getBoundingClientRect().height : 0);
            const state = { opening };
            expansionStates.set(element, state);
            const done = () => {
              if (expansionStates.get(element) !== state) return;
              element.style.overflow = '';
              finish();
              expansionStates.delete(element);
            };
            element.style.overflow = 'hidden';
            state.animation = animate(element, [{height: `${height}px`}, {height: `${target}px`}]);
            if (state.animation) {
              state.animation.addEventListener('finish', done);
              state.animation.addEventListener('cancel', done);
            } else done();
          };
          this.querySelectorAll('.pet-faq details').forEach((details) => {
            on(details.querySelector('summary'), 'click', (event) => {
              event.preventDefault();
              const opening = !(expansionStates.get(details)?.opening ?? details.open);
              expand(details, opening, () => { details.open = true; }, () => { details.open = opening; });
            });
          });
          const carousel = this.querySelector('.pet-review-carousel');
          const slides = Array.from(this.querySelectorAll('.pet-review-card'));
          const counter = carousel?.querySelector('output');
          const navigation = carousel?.querySelector('.pet-review-nav');
          let current = 0;
          const show = (next) => {
            if (!slides.length) return;
            const previous = current;
            current = (next + slides.length) % slides.length;
            slides.forEach((slide, index) => {
              slide.hidden = index !== current;
            });
            if (previous !== current) {
              slides[current].querySelectorAll('p, footer').forEach((text) => {
                text.getAnimations().forEach((animation) => animation.cancel());
                animate(text, [{opacity: 0, transform: `translateX(${next > previous ? 24 : -24}px)`}, {opacity: 1, transform: 'translateX(0)'}], 440);
              });
            }
            if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
          };
          if (carousel) carousel.hidden = slides.length === 0;
          if (navigation) navigation.hidden = slides.length < 2;
          on(carousel?.querySelector('[data-review-prev]'), 'click', () => show(current - 1));
          on(carousel?.querySelector('[data-review-next]'), 'click', () => show(current + 1));
          on(carousel, 'keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            show(current + (event.key === 'ArrowRight' ? 1 : -1));
          });
          let origin = null;
          on(
            carousel,
            'touchstart',
            (event) => {
              origin = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
            },
            { passive: true },
          );
          on(
            carousel,
            'touchend',
            (event) => {
              if (!origin || !event.changedTouches.length) return;
              const dx = event.changedTouches[0].clientX - origin.x;
              const dy = event.changedTouches[0].clientY - origin.y;
              if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) show(current + (dx < 0 ? 1 : -1));
              origin = null;
            },
            { passive: true },
          );
          on(carousel, 'touchcancel', () => {
            origin = null;
          });
          on(this, 'shopify:block:select', (event) => {
            const card = event.target.closest('.pet-review-card');
            if (card) show(slides.indexOf(card));
          });
          show(0);
          const toggle = this.querySelector('.pet-price-toggle');
          const extra = this.querySelector('#pet-extra-prices');
          on(toggle, 'click', () => {
            const opening = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(opening));
            toggle.querySelector('span').textContent = opening ? '−' : '+';
            expand(extra, opening, () => { extra.hidden = false; }, () => { extra.hidden = !opening; });
          });
          this.querySelectorAll('dialog').forEach((modal) => {
            let opener;
            const selector = modal.id === 'pet-size-modal' ? '[data-pet-size]' : '[data-pet-policy]';
            this.querySelectorAll(selector).forEach((button) => on(button, 'click', () => {
              opener = button;
              modal.showModal();
              animate(modal, [{opacity: 0, transform: 'translateY(14px) scale(.98)'}, {opacity: 1, transform: 'translateY(0) scale(1)'}], 300);
            }));
            modal.querySelectorAll('[data-pet-close]').forEach((button) => on(button, 'click', () => modal.close()));
            on(modal, 'close', () => opener?.focus({preventScroll:true}));
            on(modal, 'click', (event) => {
              const rect = modal.getBoundingClientRect();
              if (event.target === modal && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) modal.close();
            });
          });
          const sticky = this.querySelector('.pet-sticky');
          const hero = document.querySelector('.pet-room-hero') || this.querySelector('.pet-hero');
          const formSection = this.querySelector('#pet-order-form');
          const updateSticky = () => {
            sticky.hidden =
              hero.getBoundingClientRect().bottom > 0 || formSection.getBoundingClientRect().top < window.innerHeight;
          };
          this.observer = new IntersectionObserver(updateSticky);
          this.observer.observe(hero);
          this.observer.observe(formSection);
          on(window, 'resize', updateSticky);
          updateSticky();
          const result = this.querySelector('[data-form-result]');
          if (result) {
            result.focus();
            result.scrollIntoView({ block: 'center' });
          }
        }
        disconnectedCallback() {
          this.querySelectorAll('dialog').forEach((modal) => modal.close());
          this.controller?.abort();
          this.controller = null;
          this.observer?.disconnect();
          this.revealObserver?.disconnect();
          this.revealAnimations?.forEach((animation) => animation.cancel());
          this.revealAnimations?.clear();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
